module.exports = __webpack_public_path__ + "static/img/IMG_0557.7e29461.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cabins/main/IMG_0557.jpg
// module id = 5gP0
// module chunks = 4